// Shop receiving accounts for Online Payment
// Fill bank IBAN / account number / bank name when you have them.

export const PAYMENT_CURRENCY = 'PKR';

export const BANK_ACCOUNT = {
  accountTitle: 'Waleed Alam',
  iban: '', // e.g. PK00XXXX...
  accountNumber: '', // bank account number
  bankName: '', // e.g. HBL, Meezan, etc.
};

export const WALLET_ACCOUNT = {
  accountTitle: 'Waleed Alam',
  accountNumber: '03314866845', // EasyPaisa / JazzCash
};
